var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_567",
    "data-name": "Group 567",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 224.862,
    height: 142.384,
    viewBox: "0 0 224.862 142.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #972957;\n      }\n\n      .cls-4 {\n        fill: #dd4c5b;\n      }\n\n      .cls-5 {\n        fill: #94193d;\n      }\n\n      .cls-6 {\n        fill: #add396;\n      }\n\n      .cls-7 {\n        fill: #a04945;\n      }\n\n      .cls-8 {\n        fill: #722132;\n      }\n\n      .cls-9 {\n        fill: #6d1a3e;\n      }\n\n      .cls-10 {\n        fill: #6c1c31;\n      }\n\n      .cls-11 {\n        fill: #471936;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    className: "cls-1",
    width: 224.862,
    height: 142.384
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    className: "cls-3",
    d: "M384.946,223.451a23.887,23.887,0,0,0,4.816-.61,24.9,24.9,0,0,1-3.569-1.112,12.67,12.67,0,0,1-1.247,1.722",
    transform: "translate(-278.36 -160.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    className: "cls-3",
    d: "M292.98,27.4c2.072-6.284,5.85-11.409,9.51-15.684a49.976,49.976,0,0,1,9-8.152A21.39,21.39,0,0,0,305.173.6c-5.429-1.448-10.8-.187-16.506,2.885-4.525,2.642-9.272,6.5-11.967,13.075a45.964,45.964,0,0,1,10.005,5.758q3.3,2.416,6.275,5.08",
    transform: "translate(-200.086 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    className: "cls-4",
    d: "M231.142,71.134c1.5,1.625,2.988,3.281,4.419,4.95a32.937,32.937,0,0,1-.513-14.978,27.867,27.867,0,0,1,1.455-4.729,17.852,17.852,0,0,0-5.94-1.311c-4.183-.063-7.878,1.956-9.452,7.639,2.931,1.545,6.386,4.538,10.031,8.428",
    transform: "translate(-159.889 -39.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    className: "cls-4",
    d: "M323.165,209.565a28.479,28.479,0,0,1-13.433-6.46,15.862,15.862,0,0,1,.626,4.069,5.947,5.947,0,0,1-3.96,5.955c9.359,3.945,17.558,1.732,21.749-3.145a23.253,23.253,0,0,1-4.981-.419",
    transform: "translate(-221.561 -146.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    className: "cls-3",
    d: "M293.177,98.307a26.807,26.807,0,0,1-7.062-21.242,31.617,31.617,0,0,1,1.41-6.423q-2.972-2.661-6.275-5.08A45.971,45.971,0,0,0,271.244,59.8a27.869,27.869,0,0,0-1.455,4.729,32.938,32.938,0,0,0,.513,14.978c5.852,6.827,10.8,13.881,12.5,19.971a28.48,28.48,0,0,0,13.433,6.46,23.251,23.251,0,0,0,4.981.419,12.621,12.621,0,0,0,1.247-1.722,25.649,25.649,0,0,1-9.286-6.331",
    transform: "translate(-194.63 -43.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    className: "cls-5",
    d: "M293.177,98.307a26.807,26.807,0,0,1-7.062-21.242,31.617,31.617,0,0,1,1.41-6.423q-2.972-2.661-6.275-5.08A45.971,45.971,0,0,0,271.244,59.8a27.869,27.869,0,0,0-1.455,4.729,32.938,32.938,0,0,0,.513,14.978c5.852,6.827,10.8,13.881,12.5,19.971a28.48,28.48,0,0,0,13.433,6.46,23.251,23.251,0,0,0,4.981.419,12.621,12.621,0,0,0,1.247-1.722,25.649,25.649,0,0,1-9.286-6.331",
    transform: "translate(-194.63 -43.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    className: "cls-6",
    d: "M198.037,81.468q.172-.983.413-1.849c-4.368-2.3-7.573-1.391-8.512,4.564-1.348,8.778,5.708,26.021,16.364,34.1,6.3,4.926,12.107,6.083,15.763,4.707q-1.016-.429-2.05-.955c-14.81-7.131-24.5-28.8-21.978-40.57",
    transform: "translate(-137.228 -56.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    className: "cls-4",
    d: "M246.569,120.078a15.85,15.85,0,0,0-.626-4.069,37.3,37.3,0,0,1-8.213-9.693,38.38,38.38,0,0,1-4.286-10.278c-1.431-1.669-2.915-3.326-4.419-4.95-3.645-3.891-7.1-6.883-10.031-8.428q-.24.867-.413,1.849c-2.517,11.765,7.169,33.439,21.978,40.57q1.033.527,2.05.955a5.946,5.946,0,0,0,3.96-5.954",
    transform: "translate(-157.771 -59.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    className: "cls-7",
    d: "M246.569,120.078a15.85,15.85,0,0,0-.626-4.069,37.3,37.3,0,0,1-8.213-9.693,38.38,38.38,0,0,1-4.286-10.278c-1.431-1.669-2.915-3.326-4.419-4.95-3.645-3.891-7.1-6.883-10.031-8.428q-.24.867-.413,1.849c-2.517,11.765,7.169,33.439,21.978,40.57q1.033.527,2.05.955a5.946,5.946,0,0,0,3.96-5.954",
    transform: "translate(-157.771 -59.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    className: "cls-3",
    d: "M285.8,150.949c-1.7-6.09-6.647-13.144-12.5-19.971a38.383,38.383,0,0,0,4.286,10.278,37.306,37.306,0,0,0,8.213,9.693",
    transform: "translate(-197.626 -94.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    className: "cls-4",
    d: "M285.8,150.949c-1.7-6.09-6.647-13.144-12.5-19.971a38.383,38.383,0,0,0,4.286,10.278,37.306,37.306,0,0,0,8.213,9.693",
    transform: "translate(-197.626 -94.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    className: "cls-8",
    d: "M285.8,150.949c-1.7-6.09-6.647-13.144-12.5-19.971a38.383,38.383,0,0,0,4.286,10.278,37.306,37.306,0,0,0,8.213,9.693",
    transform: "translate(-197.626 -94.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    className: "cls-3",
    d: "M402.341,222.841a23.887,23.887,0,0,0,4.816.61,12.654,12.654,0,0,1-1.247-1.722,24.866,24.866,0,0,1-3.569,1.112",
    transform: "translate(-290.939 -160.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    className: "cls-3",
    d: "M411.339,11.713c3.659,4.275,7.437,9.4,9.51,15.684q2.972-2.66,6.275-5.08a45.966,45.966,0,0,1,10.005-5.758c-2.7-6.572-7.442-10.433-11.967-13.075C419.458.413,414.085-.849,408.656.6a21.384,21.384,0,0,0-6.315,2.962,49.957,49.957,0,0,1,9,8.152",
    transform: "translate(-290.939 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    className: "cls-3",
    d: "M355.871,64.005c0-6.161,3.322-12.125,7.514-17.589a75.942,75.942,0,0,1,9.129-9.719c-2.073-6.284-5.85-11.409-9.51-15.684a49.967,49.967,0,0,0-9-8.152,49.966,49.966,0,0,0-9,8.152c-3.66,4.275-7.437,9.4-9.51,15.684a75.94,75.94,0,0,1,9.129,9.719c4.192,5.464,7.511,11.428,7.514,17.589a11.917,11.917,0,0,1-1.7,6.688,24.877,24.877,0,0,0,3.57,1.112,24.878,24.878,0,0,0,3.57-1.112,11.915,11.915,0,0,1-1.7-6.688",
    transform: "translate(-242.603 -9.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    className: "cls-9",
    d: "M355.871,64.005c0-6.161,3.322-12.125,7.514-17.589a75.942,75.942,0,0,1,9.129-9.719c-2.073-6.284-5.85-11.409-9.51-15.684a49.967,49.967,0,0,0-9-8.152,49.966,49.966,0,0,0-9,8.152c-3.66,4.275-7.437,9.4-9.51,15.684a75.94,75.94,0,0,1,9.129,9.719c4.192,5.464,7.511,11.428,7.514,17.589a11.917,11.917,0,0,1-1.7,6.688,24.877,24.877,0,0,0,3.57,1.112,24.878,24.878,0,0,0,3.57-1.112,11.915,11.915,0,0,1-1.7-6.688",
    transform: "translate(-242.603 -9.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    className: "cls-3",
    d: "M337.036,126.612a25.649,25.649,0,0,0,9.286,6.331,11.917,11.917,0,0,0,1.7-6.688c0-6.161-3.322-12.125-7.514-17.589a75.972,75.972,0,0,0-9.129-9.719,31.617,31.617,0,0,0-1.41,6.423,26.807,26.807,0,0,0,7.062,21.242",
    transform: "translate(-238.489 -71.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    className: "cls-4",
    d: "M337.036,126.612a25.649,25.649,0,0,0,9.286,6.331,11.917,11.917,0,0,0,1.7-6.688c0-6.161-3.322-12.125-7.514-17.589a75.972,75.972,0,0,0-9.129-9.719,31.617,31.617,0,0,0-1.41,6.423,26.807,26.807,0,0,0,7.062,21.242",
    transform: "translate(-238.489 -71.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    className: "cls-10",
    d: "M337.036,126.612a25.649,25.649,0,0,0,9.286,6.331,11.917,11.917,0,0,0,1.7-6.688c0-6.161-3.322-12.125-7.514-17.589a75.972,75.972,0,0,0-9.129-9.719,31.617,31.617,0,0,0-1.41,6.423,26.807,26.807,0,0,0,7.062,21.242",
    transform: "translate(-238.489 -71.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    className: "cls-4",
    d: "M437.525,207.174a15.849,15.849,0,0,1,.626-4.069,28.481,28.481,0,0,1-13.433,6.46,23.253,23.253,0,0,1-4.981.419c4.19,4.878,12.39,7.09,21.749,3.145a5.946,5.946,0,0,1-3.96-5.954",
    transform: "translate(-303.517 -146.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    className: "cls-4",
    d: "M528.924,76.084c1.431-1.67,2.915-3.326,4.419-4.951,3.646-3.891,7.1-6.883,10.031-8.429-1.574-5.683-5.269-7.7-9.452-7.639a17.838,17.838,0,0,0-5.94,1.311,27.888,27.888,0,0,1,1.455,4.729,32.942,32.942,0,0,1-.513,14.979",
    transform: "translate(-381.791 -39.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    className: "cls-3",
    d: "M421.461,105.942a28.481,28.481,0,0,0,13.433-6.46c1.7-6.09,6.647-13.144,12.5-19.97a32.94,32.94,0,0,0,.513-14.979,27.875,27.875,0,0,0-1.455-4.729,45.981,45.981,0,0,0-10.005,5.758q-3.3,2.416-6.275,5.08a31.663,31.663,0,0,1,1.41,6.424,26.808,26.808,0,0,1-7.063,21.242,25.649,25.649,0,0,1-9.286,6.331,12.632,12.632,0,0,0,1.247,1.722,23.252,23.252,0,0,0,4.981-.419",
    transform: "translate(-300.26 -43.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    className: "cls-5",
    d: "M421.461,105.942a28.481,28.481,0,0,0,13.433-6.46c1.7-6.09,6.647-13.144,12.5-19.97a32.94,32.94,0,0,0,.513-14.979,27.875,27.875,0,0,0-1.455-4.729,45.981,45.981,0,0,0-10.005,5.758q-3.3,2.416-6.275,5.08a31.663,31.663,0,0,1,1.41,6.424,26.808,26.808,0,0,1-7.063,21.242,25.649,25.649,0,0,1-9.286,6.331,12.632,12.632,0,0,0,1.247,1.722,23.252,23.252,0,0,0,4.981-.419",
    transform: "translate(-300.26 -43.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    className: "cls-3",
    d: "M416.562,108.667c-4.192,5.464-7.511,11.428-7.514,17.589a11.917,11.917,0,0,0,1.7,6.688,25.651,25.651,0,0,0,9.286-6.331,26.808,26.808,0,0,0,7.062-21.242,31.618,31.618,0,0,0-1.41-6.423,75.958,75.958,0,0,0-9.129,9.719",
    transform: "translate(-295.781 -71.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    className: "cls-3",
    d: "M416.562,108.667c-4.192,5.464-7.511,11.428-7.514,17.589a11.917,11.917,0,0,0,1.7,6.688,25.651,25.651,0,0,0,9.286-6.331,26.808,26.808,0,0,0,7.062-21.242,31.618,31.618,0,0,0-1.41-6.423,75.958,75.958,0,0,0-9.129,9.719",
    transform: "translate(-295.781 -71.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    className: "cls-10",
    d: "M416.562,108.667c-4.192,5.464-7.511,11.428-7.514,17.589a11.917,11.917,0,0,0,1.7,6.688,25.651,25.651,0,0,0,9.286-6.331,26.808,26.808,0,0,0,7.062-21.242,31.618,31.618,0,0,0-1.41-6.423,75.958,75.958,0,0,0-9.129,9.719",
    transform: "translate(-295.781 -71.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    className: "cls-6",
    d: "M530.411,84.183c-.939-5.955-4.144-6.866-8.512-4.564q.24.867.413,1.849c2.517,11.766-7.169,33.439-21.979,40.57q-1.032.527-2.049.955c3.656,1.376,9.46.22,15.763-4.707,10.656-8.082,17.712-25.325,16.364-34.1",
    transform: "translate(-360.316 -56.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    className: "cls-4",
    d: "M511.968,84.508q-.172-.983-.413-1.849c-2.931,1.546-6.385,4.538-10.031,8.428-1.5,1.625-2.988,3.281-4.419,4.951a38.379,38.379,0,0,1-4.286,10.278,37.3,37.3,0,0,1-8.213,9.693,15.862,15.862,0,0,0-.627,4.069,5.947,5.947,0,0,0,3.96,5.955q1.016-.429,2.05-.955c14.809-7.131,24.5-28.8,21.978-40.57",
    transform: "translate(-349.973 -59.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    className: "cls-7",
    d: "M511.968,84.508q-.172-.983-.413-1.849c-2.931,1.546-6.385,4.538-10.031,8.428-1.5,1.625-2.988,3.281-4.419,4.951a38.379,38.379,0,0,1-4.286,10.278,37.3,37.3,0,0,1-8.213,9.693,15.862,15.862,0,0,0-.627,4.069,5.947,5.947,0,0,0,3.96,5.955q1.016-.429,2.05-.955c14.809-7.131,24.5-28.8,21.978-40.57",
    transform: "translate(-349.973 -59.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    className: "cls-3",
    d: "M494.457,141.257a38.377,38.377,0,0,0,4.286-10.278c-5.851,6.827-10.8,13.881-12.5,19.971a37.3,37.3,0,0,0,8.213-9.693",
    transform: "translate(-351.61 -94.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    className: "cls-4",
    d: "M494.457,141.257a38.377,38.377,0,0,0,4.286-10.278c-5.851,6.827-10.8,13.881-12.5,19.971a37.3,37.3,0,0,0,8.213-9.693",
    transform: "translate(-351.61 -94.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    className: "cls-8",
    d: "M494.457,141.257a38.377,38.377,0,0,0,4.286-10.278c-5.851,6.827-10.8,13.881-12.5,19.971a37.3,37.3,0,0,0,8.213-9.693",
    transform: "translate(-351.61 -94.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    className: "cls-11",
    d: "M285.857,263.606c5.243-.4,10.486-.611,15.729-.753s10.486-.212,15.73-.215,10.486.059,15.729.213,10.486.353,15.73.756c-5.243.4-10.486.614-15.73.756s-10.486.212-15.729.213-10.486-.061-15.73-.215-10.486-.352-15.729-.753",
    transform: "translate(-206.707 -189.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    className: "cls-11",
    d: "M374.708,231.169l.822,8.087h2.559l-.8-10.292a13.781,13.781,0,0,1-2.581,2.205",
    transform: "translate(-270.957 -165.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    className: "cls-11",
    d: "M356.376,242.761a17.072,17.072,0,0,1-2.495.691l.849,5.759h2.559l-.8-6.48Z",
    transform: "translate(-255.897 -175.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    className: "cls-11",
    d: "M418.562,228.965l-.8,10.292h2.559l.822-8.087a13.791,13.791,0,0,1-2.581-2.205",
    transform: "translate(-302.09 -165.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    className: "cls-11",
    d: "M439.414,242.765l-.122-.033-.8,6.48h2.559l.849-5.759a17.078,17.078,0,0,1-2.486-.688",
    transform: "translate(-317.08 -175.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    className: "cls-11",
    d: "M397.622,225.746c-.6.137-1.2.246-1.807.338l.46,10.845h2.694l.46-10.845c-.608-.093-1.212-.2-1.807-.338",
    transform: "translate(-286.22 -163.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    className: "cls-11",
    d: "M8.357,297.541q4.692,0,7.832.208a24.1,24.1,0,0,1,4.509.6,11.869,11.869,0,0,1,5.437,2.871,6.258,6.258,0,0,1,1.821,4.533,6.162,6.162,0,0,1-2.089,4.679,13.571,13.571,0,0,1-6.146,2.92,16.26,16.26,0,0,1,7.563,3.2,7.053,7.053,0,0,1,2.578,5.572,7.984,7.984,0,0,1-1.527,4.924,10.482,10.482,0,0,1-4.631,3.287,19.734,19.734,0,0,1-5.009,1.051,80.171,80.171,0,0,1-8.186.342H1.588L0,330.285q.2-4.325.293-8.235t.1-7.551q0-3.641-.1-7.453T0,299.154l1.686-1.613Zm1.149,15.908a12.918,12.918,0,0,0,6.854-1.967,5.413,5.413,0,0,0,2.407-4.631,5.628,5.628,0,0,0-2.419-4.765,11.793,11.793,0,0,0-6.7-1.93Zm.146,15.688Q15,328.8,17.777,327.06a5.4,5.4,0,0,0-.049-9.469q-2.822-1.723-8.223-2.04Z",
    transform: "translate(0 -215.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    className: "cls-11",
    d: "M154.573,313.392a17.822,17.822,0,0,1-1.112,6.39,15.742,15.742,0,0,1-3.336,5.266,18.55,18.55,0,0,1-6.427,4.4,20.764,20.764,0,0,1-7.942,1.49,18.512,18.512,0,0,1-6.292-1.038,15.255,15.255,0,0,1-5.119-3.043,16.6,16.6,0,0,1-4.13-5.975,19.254,19.254,0,0,1-1.515-7.538,18.01,18.01,0,0,1,1.539-7.478,15.563,15.563,0,0,1,4.472-5.791,18.561,18.561,0,0,1,5.853-3.214,21.708,21.708,0,0,1,6.952-1.088,19.379,19.379,0,0,1,5.95.868,14.676,14.676,0,0,1,4.85,2.627,16.213,16.213,0,0,1,4.631,6.109,19.554,19.554,0,0,1,1.625,8.015m-20.356-14.417a11.074,11.074,0,0,0-3.714,4.741,17.338,17.338,0,0,0-1.295,6.915,20.849,20.849,0,0,0,2.48,10.605,13.662,13.662,0,0,0,7.123,6.06,11.4,11.4,0,0,0,3.922-4.765,16.644,16.644,0,0,0,1.332-6.891A20.574,20.574,0,0,0,141.512,305a13.59,13.59,0,0,0-7.294-6.024",
    transform: "translate(-85.834 -213.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    className: "cls-11",
    d: "M244.582,330.2l-1-2.688a6.964,6.964,0,0,0,1.185.33,6.679,6.679,0,0,0,1.209.11,5.771,5.771,0,0,0,4.936-2.15q1.613-2.15,1.613-6.6,0-1.832-.049-4.2t-.049-2.908q0-7.5,3.177-11.558t9.041-4.056a13.356,13.356,0,0,1,3.152.367,14.844,14.844,0,0,1,3.055,1.124l1,2.517q-.783-.147-1.5-.232a11.544,11.544,0,0,0-1.356-.086,5.1,5.1,0,0,0-4.765,2.444q-1.442,2.444-1.442,8.186,0,.269.024,1.833t.024,2.859a31.129,31.129,0,0,1-.562,6.683,11.015,11.015,0,0,1-1.833,4.142,11.985,11.985,0,0,1-4.411,3.653,13.39,13.39,0,0,1-5.853,1.234,17.464,17.464,0,0,1-3.055-.244,11.237,11.237,0,0,1-2.541-.758",
    transform: "translate(-176.136 -214.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    className: "cls-11",
    d: "M368.778,326.442a38.224,38.224,0,0,0,3.677,2.969,39.135,39.135,0,0,0,4.069,2.529,31.756,31.756,0,0,0-4.423,3.128,30.109,30.109,0,0,0-3.788,3.837,51.531,51.531,0,0,0-3.763-4.337,54.442,54.442,0,0,0-4.3-3.971q-1.026.147-1.894.22t-1.649.073a17.641,17.641,0,0,1-6.072-1.026,14.922,14.922,0,0,1-5-3.006,16.37,16.37,0,0,1-4.105-5.962,19.5,19.5,0,0,1-1.491-7.551,18.086,18.086,0,0,1,1.527-7.5A15.6,15.6,0,0,1,346,300.075a18.512,18.512,0,0,1,5.877-3.214,21.932,21.932,0,0,1,6.976-1.088,19.027,19.027,0,0,1,5.913.868,15.032,15.032,0,0,1,4.839,2.627,16.508,16.508,0,0,1,4.668,6.1,18.883,18.883,0,0,1,1.637,7.856,15.866,15.866,0,0,1-1.759,7.624,15.284,15.284,0,0,1-5.376,5.6m-13.22-27.466a11.075,11.075,0,0,0-3.714,4.741,17.337,17.337,0,0,0-1.295,6.915,20.849,20.849,0,0,0,2.48,10.605,13.662,13.662,0,0,0,7.123,6.06,11.409,11.409,0,0,0,3.922-4.765,16.648,16.648,0,0,0,1.331-6.891A20.571,20.571,0,0,0,362.852,305a13.59,13.59,0,0,0-7.294-6.024",
    transform: "translate(-245.889 -213.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    className: "cls-11",
    d: "M509.275,331.726q.073-1.246.11-2.493t.037-2.468a40.025,40.025,0,0,1-7.306,3.959,16.516,16.516,0,0,1-5.963,1.246q-4.643,0-6.622-2.774t-1.979-9.42v-6.109q0-2.932-.1-6.463t-.293-8.052l1.711-1.613q1.637.123,2.48.159t1.6.037q1.368,0,4.105-.171h.146q-.171,3.837-.256,8.345t-.086,9.86q0,5.914,1.381,8.027t4.924,2.114a9.827,9.827,0,0,0,3.054-.5,13.421,13.421,0,0,0,3.152-1.552v-.709q.1-7.843.1-11.485,0-4.007-.049-7.478t-.146-6.622q1.71.1,2.566.134t1.588.037q.733,0,1.6-.037t2.383-.159l1.71,1.613q-.172,3.568-.256,7.368t-.086,7.978q0,4.179.086,8.088t.256,7.7l-1.613,1.442q-.977-.074-2.016-.11t-2.065-.037q-1.026,0-2.077.037t-2.077.11",
    transform: "translate(-352.273 -215.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    className: "cls-11",
    d: "M652.773,297.363l-1.881,3.91q-1.662-.1-3.47-.147t-3.885-.049q-1.565,0-2.334.012t-1.43.037v26.66q.538,0,1.589.024t1.564.025q2.053,0,4.276-.086t4.887-.256l2.15,4.154q-2.663-.122-5.632-.183t-6.585-.061q-3.079,0-5.694.049t-4.961.146l-1.588-1.442q.2-4.325.294-8.235t.1-7.551q0-3.641-.1-7.453t-.294-7.893l1.711-1.662q3.006.122,5.6.184t4.985.061q2.443,0,5.095-.061t5.608-.184m-7.419,17.264H634.025v-3.781h13.106Z",
    transform: "translate(-455.402 -215.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    className: "cls-11",
    d: "M711,330.2l-1-2.688a6.962,6.962,0,0,0,1.185.33,6.681,6.681,0,0,0,1.209.11,5.77,5.77,0,0,0,4.936-2.15q1.613-2.15,1.613-6.6,0-1.832-.049-4.2t-.049-2.908q0-7.5,3.177-11.558t9.041-4.056a13.357,13.357,0,0,1,3.152.367,14.844,14.844,0,0,1,3.055,1.124l1,2.517q-.782-.147-1.5-.232a11.544,11.544,0,0,0-1.356-.086,5.1,5.1,0,0,0-4.765,2.444q-1.442,2.444-1.442,8.186,0,.269.024,1.833t.025,2.859a31.128,31.128,0,0,1-.562,6.683,11.02,11.02,0,0,1-1.833,4.142,11.983,11.983,0,0,1-4.411,3.653A13.389,13.389,0,0,1,716.6,331.2a17.465,17.465,0,0,1-3.055-.244A11.241,11.241,0,0,1,711,330.2",
    transform: "translate(-513.413 -214.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    className: "cls-3",
    d: "M175.308,471.155H179.2c3.588,0,5.947,2.143,5.947,5.848,0,3.721-2.359,5.881-5.947,5.881h-3.887Zm3.771,10.3c2.641,0,4.369-1.562,4.369-4.452a4.039,4.039,0,0,0-4.369-4.419h-2.126v8.871Z",
    transform: "translate(-126.768 -340.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    className: "cls-3",
    d: "M219.707,471.155h6.811v1.429h-5.167v3.671h4.2v1.429h-4.2v3.771H226.8v1.429h-7.094Z",
    transform: "translate(-158.873 -340.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    className: "cls-3",
    d: "M269.986,470.615h4.369c2.376,0,4.037,1.063,4.037,3.106a2.9,2.9,0,0,1-1.379,2.525v.033a2.663,2.663,0,0,1,1.861,2.675c0,2.591-2.16,3.538-4.519,3.538h-4.369Zm4.4,4.6a1,1,0,0,0,1.046-1.1.966.966,0,0,0-1.1-1.013h-1.445v2.11Zm.249,4.784a1.18,1.18,0,0,0,1.263-1.246,1.142,1.142,0,0,0-1.246-1.213h-1.761V480Z",
    transform: "translate(-195.231 -340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    className: "cls-3",
    d: "M312.8,469.895a6.008,6.008,0,0,1,6.213,6.064,6.213,6.213,0,0,1-12.426,0,6.008,6.008,0,0,1,6.213-6.064m0,9.618a3.35,3.35,0,0,0,3.206-3.555,3.212,3.212,0,1,0-6.412,0,3.351,3.351,0,0,0,3.206,3.555",
    transform: "translate(-221.697 -339.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    className: "cls-3",
    d: "M361.9,469.895a6.189,6.189,0,0,1,4.452,1.678L365,473.766a4.985,4.985,0,0,0-2.974-1.212,3.21,3.21,0,0,0-3.356,3.389,3.379,3.379,0,0,0,3.356,3.572,4.87,4.87,0,0,0,3.157-1.462l1.495,2.126a6.517,6.517,0,0,1-4.784,1.993,5.958,5.958,0,0,1-6.23-6.163,6.043,6.043,0,0,1,6.23-6.113",
    transform: "translate(-257.187 -339.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    className: "cls-3",
    d: "M401.806,470.615h2.907v4.751h4.319v-4.751h2.907v11.878h-2.907v-4.651h-4.319v4.651h-2.907Z",
    transform: "translate(-290.552 -340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    className: "cls-3",
    d: "M450.614,480h-3.7l-.714,2.492H443.2l4.037-11.878H450.3l4.037,11.878h-2.99Zm-1.861-6.678s-.266,1.3-.482,2.043l-.681,2.309h2.342l-.665-2.309c-.216-.747-.482-2.043-.482-2.043Z",
    transform: "translate(-320.488 -340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    className: "cls-3",
    d: "M488.2,470.615h2.907V480h4.851v2.492H488.2Z",
    transform: "translate(-353.027 -340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    className: "cls-3",
    d: "M521.983,470.615h7.442v2.492H524.89v2.16h3.622v2.492H524.89V480h4.768v2.492h-7.675Z",
    transform: "translate(-377.454 -340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    className: "cls-3",
    d: "M556.923,470.615h3.156l1.728,5.017c.266.764.6,1.96.6,1.96h.033s.332-1.2.6-1.96l1.728-5.017h3.157l.963,11.878h-2.907l-.365-5.349a17.673,17.673,0,0,1,0-1.993h-.033s-.4,1.246-.665,1.993l-1.246,3.439h-2.492l-1.246-3.439c-.266-.748-.664-1.993-.664-1.993h-.033a17.754,17.754,0,0,1,0,1.993l-.366,5.349h-2.924Z",
    transform: "translate(-402.01 -340.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    className: "cls-3",
    d: "M613.572,480h-3.7l-.714,2.492h-2.99l4.037-11.878h3.057l4.037,11.878H614.3Zm-1.861-6.678s-.266,1.3-.482,2.043l-.681,2.309h2.342l-.664-2.309c-.216-.747-.482-2.043-.482-2.043Z",
    transform: "translate(-438.325 -340.308)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.ad2b7b9f8b2d80507a1db0b44d5fe38c.svg";
export { ForwardRef as ReactComponent };